interface HandleLineClampAdjustment {
  containerElement: HTMLElement
  spacingAroundContainer?: number
  spacingBelowTitle?: number
  customLineToRemove?: number
}

/* Assuming there is title and description within container with fixed height. */
export function handleLineClampAdjustment({
  containerElement,
  spacingAroundContainer = 0,
  spacingBelowTitle = 0,
  customLineToRemove = 0
}: HandleLineClampAdjustment) {
  const containerHeight = containerElement.offsetHeight
  const [title, description] = (containerElement.childNodes as unknown) as [
    HTMLElement,
    HTMLElement
  ]
  /* Title can break into 2 lines */
  const titleLineHeight = parseInt(window.getComputedStyle(title).lineHeight)
  if (isNaN(titleLineHeight)) {
    console.error('handleLineClampAdjustment not working properly')
    return
  }
  const titleLineCount = Math.floor(title.offsetHeight / titleLineHeight)
  const descriptionLineHeight = parseInt(
    window.getComputedStyle(description).lineHeight
  )
  const availableSpaceForDescription =
    containerHeight - spacingAroundContainer - spacingBelowTitle
  /* Max lines available for description */
  const maxLines = Math.floor(
    availableSpaceForDescription / descriptionLineHeight
  )
  const clampLines = Math.max(3, maxLines - titleLineCount - customLineToRemove)

  description.style.webkitLineClamp = clampLines.toString()
}
